/**
 * UUIDs de variations que não devem ter divisão por 12
 */
export const EXCLUDED_VARIATION_UUIDS = [
  'c1a42d93-fda2-4486-be52-bc644148cecb',
  '103adc06-8973-4335-ae7b-8d586ebba6ce',
  'a284726a-5061-40dc-944c-697580ab7eca',
  '3fef72cb-5b62-48ba-bc67-6d1bba913323',
  'a98bd7cf-66ed-45b0-87c8-f1cdfb2fa4fa',
  '208ed3a2-8dbd-483c-a533-4b1582f9be72',
  'd8dcca21-5d32-4ea0-9666-7c50c6714417',
  '657817e2-ba84-4de4-9331-b0b371760ef5',
  'f06de2e9-7b8a-4203-a2a9-9ade3c02f6a6',
  '142f3f68-31ca-43df-81ed-66cbee9a11e7',
  '0aac00b3-f321-4062-b3d1-25778ec56a80',
  '861cc763-9fb5-4139-a04f-4d7a9bc80216',
  '632a0d5b-5593-4ec7-892a-36a55e8d52a7',

  // de HML para teste
  '4f22b82a-ab88-4b0d-8469-f64187f90f47',
  '3e95ea6b-f830-433e-a9a5-3b346aab48b6', // Site Pronto
  '89fd45ba-13bf-4cde-bcae-5bc36a969d85', // Construtor de Sites (Pessoal)
  'e4fef757-e6d9-4406-9d28-ca8a60396f2b', // Construtor de Sites (Profissional)
  '25b676ec-cc41-4802-b032-52049198c44b', // Hospedagem de Sites (Pessoal)
  '5832d037-ad0a-4b83-aaf8-3cdbda1b3930', // Hospedagem de Sites (Profissional)
  'f1670933-de9e-4381-aa2e-073ce07a1486', // Hospedagem de Sites (Empresarial)
  '431b6bc9-4fb3-472e-bfcd-cdc3b36b3912', // Registro de domínio | .com.br
  //TODO: passar o uuid de prod - Produto integração parceiros
  'bb0d8fb4-0e75-4428-9763-9ad1f6af2dc2',

  // Email Empresarial
  // '84870116-d236-479c-a78f-f926e3ba74b4', // Email Empresarial - Pacote com 50
  // 'd527c493-b635-4882-bf9c-074844829925', // Email Empresarial - Pacote com 20
  // '9fdeeddf-6128-4dd7-b965-a17be2ababd6', // Email Empresarial - Pacote com 10
  // '8f7d9e89-9e2f-4252-ab7d-557c8fe0e732', // Email Empresarial - Pacote com 5
  // '490c0a0a-7116-4003-8eba-0962cfc000f5', // Email Empresarial - Pacote com 100
];

export const NO_EXISTING_DOMAIN_VARIATION_UUIDS = [
  '431b6bc9-4fb3-472e-bfcd-cdc3b36b3912', // HML
  'a98bd7cf-66ed-45b0-87c8-f1cdfb2fa4fa', // PRD
];

export const SITE_PRONTO_UUIDS = [
  '632a0d5b-5593-4ec7-892a-36a55e8d52a7', // PRD
  '3e95ea6b-f830-433e-a9a5-3b346aab48b6', // HML
];

export const REGISTRY_DOMAIN_UUIDS = [
  'a98bd7cf-66ed-45b0-87c8-f1cdfb2fa4fa', // PRD
  '431b6bc9-4fb3-472e-bfcd-cdc3b36b3912', // HML
];

/** Produto "Registro de domínio" (standalone no carrinho). */
export const REGISTRY_DOMAIN_PRODUCT_UUIDS = [
  '01391c9c-35fd-4d89-a1f0-0b24bfc2d71a', // PRD
  'f2489696-3a71-4c6e-ae95-70f289b81720', // HML
];

export const EMAIL_EMPRESARIAL_UUIDS = [
  // HML
  '84870116-d236-479c-a78f-f926e3ba74b4', // Email Empresarial - Pacote com 50
  'd527c493-b635-4882-bf9c-074844829925', // Email Empresarial - Pacote com 20
  '9fdeeddf-6128-4dd7-b965-a17be2ababd6', // Email Empresarial - Pacote com 10
  '8f7d9e89-9e2f-4252-ab7d-557c8fe0e732', // Email Empresarial - Pacote com 5
  '490c0a0a-7116-4003-8eba-0962cfc000f5', // Email Empresarial - Pacote com 100

  // PRD
  'b491528f-fd55-4b23-83bf-f9ea79622757', // Email Empresarial - Pacote com 50
  '33eaeca8-7070-4e50-b8d0-5abcbd5e46ec', // Email Empresarial - Pacote com 20
  '5e319c73-6c79-4ff2-9bfc-11fef56f6246', // Email Empresarial - Pacote com 10
  'bbae2d08-4a4c-41bc-a90d-ba1eae1d5f37', // Email Empresarial - Pacote com 5
  '07e26530-92fd-438f-8aaf-cf573eba1110', // Email Empresarial - Pacote com 100
];

/** Presença Digital com domínio incluso grátis no 1º ano. */
export const FREE_DOMAIN_INCLUDED_UUIDS = [
  // PRD
  '632a0d5b-5593-4ec7-892a-36a55e8d52a7', // Site Pronto
  'd8dcca21-5d32-4ea0-9666-7c50c6714417', // Construtor de Sites (Pessoal)
  '208ed3a2-8dbd-483c-a533-4b1582f9be72', // Construtor de Sites (Profissional)
  'a284726a-5061-40dc-944c-697580ab7eca', // Hospedagem de Sites (Pessoal)
  '103adc06-8973-4335-ae7b-8d586ebba6ce', // Hospedagem de Sites (Profissional)
  'c1a42d93-fda2-4486-be52-bc644148cecb', // Hospedagem de Sites (Empresarial)

  // HML
  '3e95ea6b-f830-433e-a9a5-3b346aab48b6', // Site Pronto
  '89fd45ba-13bf-4cde-bcae-5bc36a969d85', // Construtor de Sites (Pessoal)
  'e4fef757-e6d9-4406-9d28-ca8a60396f2b', // Construtor de Sites (Profissional)
  '25b676ec-cc41-4802-b032-52049198c44b', // Hospedagem de Sites (Pessoal)
  '5832d037-ad0a-4b83-aaf8-3cdbda1b3930', // Hospedagem de Sites (Profissional)
  'f1670933-de9e-4381-aa2e-073ce07a1486', // Hospedagem de Sites (Empresarial)
];

export const PRESENCA_DIGITAL_UUIDS = [
  ...FREE_DOMAIN_INCLUDED_UUIDS,
  ...REGISTRY_DOMAIN_UUIDS,
];
